import React, { Component, PropTypes } from 'react';

export default class ChartingCheckbox extends Component {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired,
        item: PropTypes.object.isRequired,
        data: PropTypes.array.isRequired,
        name: PropTypes.string.isRequired
    };

    state = {
        checked: false
    };

    handleChange = (e) => {
        this.props.onChange(e);
    };

    checkForNewValues = (item, data) => {
        let checked = false;
        let itemIndex = data.findIndex((find) => {
            // eslint-disable-next-line
            return find.param == item.value;
        });

        if (itemIndex >= 0) {
            checked = data[itemIndex].value;
        }

        this.setState({
            checked
        });
    };

    componentDidMount() {
        this.checkForNewValues(this.props.item, this.props.data);
    }

    componentWillReceiveProps(nextProps) {
        this.checkForNewValues(nextProps.item, nextProps.data);
    }

    render() {
        const { checked } = this.state;
        const { item, id, name } = this.props;

        return (
            <div className="md-checkbox-list" style={{margin: '15px 0'}}>
                <div className="md-checkbox">
                    <input type="checkbox" name={name}
                           id={id}
                           checked={checked}
                           onChange={this.handleChange}
                           className="md-check" data-value={item.value}/>

                    <label htmlFor={id}>
                        <span/>
                        <span className="check"/>
                        <span className="box"/> {item.label}
                    </label>
                </div>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/patient/Charting/ChartingCheckbox.js
 **/